import { render } from "./ComponentCard.vue?vue&type=template&id=2a56c624&ts=true"
import script from "./ComponentCard.vue?vue&type=script&lang=ts"
export * from "./ComponentCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__